import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup, Checkbox } from 'react-bootstrap';

const CarryingGoods = (props) => {
  return (
    <FormGroup controlId="carryingGoods">

      <Col sm={1}>
        <Checkbox
          inline
          onClick={props.handleChangeCarryingGoods}
          checked={props.carryingGoods}
          name="carryingGoods" />
      </Col>
      <Col componentClass={ControlLabel} sm={11}>
        Carrying Goods
      </Col>
    </FormGroup>
  )
}

CarryingGoods.propTypes = {
  carryingGoods: PropTypes.bool,
  handleChangeCarryingGoods: PropTypes.func
};

export default CarryingGoods;



// WEBPACK FOOTER //
// ./src/app/components/carryingGoods/CarryingGoods.js